import type { ReactNode } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

interface Props {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
  /** Optional badge/pill rendered to the right of the title. */
  headerExtra?: ReactNode
  /** Optional max-width override (Tailwind class, e.g. `sm:max-w-2xl`). */
  className?: string
}

/**
 * Thin wrapper over shadcn Dialog so the existing call sites
 * (`<Modal open ... headerExtra=...>`) keep working unchanged.
 */
export function Modal({ open, onClose, title, children, headerExtra, className }: Props) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className={cn('sm:max-w-lg', className)}>
        <DialogHeader>
          <div className="flex items-center justify-between gap-2 pr-6">
            <DialogTitle>{title}</DialogTitle>
            {headerExtra}
          </div>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  )
}
